const releaseStatus = {
  NEW: 1,
  CONFIRMED: 2
}

const releaseTypes = {
  FIRM: 1,
  FORECAST: 2
}

export { releaseStatus, releaseTypes }
